import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ui-label-input" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["placeholder", "id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "label"
    }, _toDisplayString(_ctx.nameLabel), 9, _hoisted_2),
    _withDirectives(_createElementVNode("input", {
      class: "input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.innerValue) = $event)),
      placeholder: _ctx.placeholder,
      id: _ctx.id
    }, null, 8, _hoisted_3), [
      [_vModelText, _ctx.innerValue]
    ])
  ]))
}